const fromRequireContext = function (reqctx) {
  return function (className) {
    let parts = className.split(`.`);
    let filename = parts.shift();
    let keys = parts;
    // Load the module:
    let component = reqctx(`./` + filename);
    // Then access each key:
    keys.forEach(function (k) {
      component = component[k];
    });
    // support `export default`
    if (component.__esModule) {
      component = component[`default`];
    }
    return component;
  };
};

let topLevel = typeof window === `undefined` ? this : window;

const fromGlobal = function (className) {
  let constructor;
  // Try to access the class globally first
  constructor = topLevel[className];

  // If that didn't work, try eval
  if (!constructor) {
    /* eslint-disable */
    constructor = eval(className);
    /* eslint-enable */
  }

  // Lastly, if there is a default attribute try that
  if (constructor && constructor[`default`]) {
    constructor = constructor[`default`];
  }

  return constructor;
};

const constructorFromRequireContextWithGlobalFallback = function (
  reqctx,
  secondReqCtx
) {
  let fromCtx = fromRequireContext(reqctx);
  let fromSecondCtx = fromRequireContext(secondReqCtx);
  return function (className) {
    let component;
    try {
      // `require` will raise an error if this className isn't found:
      component = fromCtx(className);
    } catch (firstErr) {
      try {
        component = fromSecondCtx(className);
      } catch (thirdErr) {
        // fallback to global:
        try {
          component = fromGlobal(className);
        } catch (secondErr) {
          /* eslint-disable */
          console.error(firstErr);
          console.error(secondErr);
          console.error(thirdErr);
          /* eslint-enable */
        }
      }
    }
    return component;
  };
};

export function useContext(requireContext, secondRequireContext) {
  this.getConstructor = constructorFromRequireContextWithGlobalFallback(
    requireContext,
    secondRequireContext
  );
}
